import { useEditor, EditorContent } from '@tiptap/react'
import { richTextDisplayExtensions } from '@/components/ui/minimal-tiptap/display-extensions'
import '@/components/ui/minimal-tiptap/styles/index.css'

const normaliseToHtml = (content: string) => {
  if (content.trimStart().startsWith('<')) return content
  return content
    .split('\n')
    .map((line) => `<p>${line || '<br>'}</p>`)
    .join('')
}

const RichTextContent = ({ content }: { content: string }) => {
  const editor = useEditor({
    extensions: richTextDisplayExtensions,
    content: normaliseToHtml(content),
    editable: false,
    immediatelyRender: false,
  })

  if (!editor) return null

  return <EditorContent editor={editor} className='minimal-tiptap-editor' />
}

export default RichTextContent
